import { EmployeeLinkFieldWithNameLoading } from 'domain/shared/employee';
import { FieldProps, useFieldHelper } from 'framework/ui/field';
import { Box, Typography } from '@mui/material';
import { AppIconLabel } from 'framework/ui/mui-builder';
import PriorityHigh from '@mui/icons-material/PriorityHigh';

const ProjectBackupTeamField = ({ tooltipTitle = 'Replacement', ...props }: FieldProps) => {
  const { getValue } = useFieldHelper(props);
  const value = getValue();

  return (
    <Box
      display="flex"
      alignItems="flex-start"
      sx={{
        '& #app-icon-span-id': {
          mr: '5px !important',
        },
      }}
    >
      <AppIconLabel sxIcon={{ width: '16px' }} icon="replacement" tooltipTitle={tooltipTitle} />
      {value ? (
        <EmployeeLinkFieldWithNameLoading {...props} />
      ) : (
        <Typography color="error">
          <PriorityHigh color="error" sx={{ fontSize: 12 }} />
          No replacement
        </Typography>
      )}
    </Box>
  );
};

export default ProjectBackupTeamField;
